function supportHoursOpen(){
    const hours = getSupportHoursForToday();
const $msg = $('.contactHours .contactOpen');
const $tel = $('.contactHours');

//console.log("Dnešní hodiny:", hours);

if (!hours) {
    // Zavřeno -> žádné hodiny nejsou definované
    $msg.removeClass('haveOpen').text(closeDaysText);
    $tel.removeClass('haveOpen');
    $('.customContactBar .left span').removeClass('haveOpen');
    $('.tilesWrap .status').removeClass('haveOpen').text(closeDaysText)
}
else if (isSupportOnline(hours)) {
    // Otevřeno právě teď
    $msg.addClass('haveOpen').html(openHoursText);
    $tel.addClass('haveOpen');
    $('.customContactBar .left span').addClass('haveOpen');
    $('.tilesWrap .status').addClass('haveOpen').html(openHoursText)
}
else {
    // Dnes je otevřeno, ale teď mimo provozní dobu
    $msg.removeClass('haveOpen').text(closeDaysText);
    $tel.removeClass('haveOpen');
    $('.customContactBar .left span').removeClass('haveOpen');
    $('.tilesWrap .status').removeClass('haveOpen').text(closeDaysText)
}


function fixedHolidays(year) {
    return [
        `${year}-01-01`,
        `${year}-05-01`,
        `${year}-05-08`,
        `${year}-07-05`,
        `${year}-07-06`,
        `${year}-09-28`,
        `${year}-10-28`,
        `${year}-11-17`,
        `${year}-12-24`,
        `${year}-12-25`,
        `${year}-12-26`,
    ];
}

function getEasterDates(year) {
    let f = Math.floor,
        a = year % 19,
        b = f(year / 100),
        c = year % 100,
        d = f(b / 4),
        e = b % 4,
        g = f((8 * b + 13) / 25),
        h = (19 * a + b - d - g + 15) % 30,
        i = f(c / 4),
        k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = f((a + 11 * h + 22 * l) / 451),
        month = f((h + l - 7 * m + 114) / 31),
        day = ((h + l - 7 * m + 114) % 31) + 1;
    const sunday = new Date(year, month - 1, day);
    const monday = new Date(year, month - 1, day + 1);
    return [
        sunday.toISOString().slice(0, 10),
        monday.toISOString().slice(0, 10),
    ];
}

function toMinutes(time) {
    if (!time) return null;
    const [h, m] = time.split(':');
    return parseInt(h) * 60 + parseInt(m);
}

function getSupportHoursForToday() {
    const now = new Date();
    const year = now.getFullYear();
    const today = now.toISOString().slice(0, 10);
    const weekday = now.getDay() === 0 ? 7 : now.getDay();
    if (manualExtendedHours[today]) {
        return manualExtendedHours[today];
    }
    if (manualClosedDays[today]) {
        return null;
    }
    const holidays = [...fixedHolidays(year), ...getEasterDates(year)];
    if (holidays.includes(today)) {
        return null;
    }
    return supportHours[weekday] || null;
}

function isSupportOnline(hours) {
    if (!hours) return false;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const open = toMinutes(hours.open);
    const close = toMinutes(hours.close);

    return currentMinutes >= open && currentMinutes < close;
}
}
